// @flow
import * as React from 'react';
import * as Import from '@ta/platform.import';
import type { MediaUploaderModalViewProps } from '@ta/media.upload';
import { Global, Closer } from '@ta/overlays.managers';
import { TitleBar } from '@ta/modal.headers';
import { localize } from '@ta/common.i18n';
import { LoadingSpinner } from '@ta/styleguide.loading';
import { ModalView } from '@ta/overlays.modal';

import styles from './MediaUploaderModal.less';

type Props = {|
  /* The modal view props  */
  ...MediaUploaderModalViewProps,
  /* the name of the modal.  Necessary because the Opener will use the same name */
  modalName: string,
|};

type DeferredMediaUploaderModalViewProps = {|
  ...MediaUploaderModalViewProps,
  closeGlobals: () => mixed,
|};

const MediaUploaderModalView = Import.component.onUsage<_, MediaUploaderModalViewProps>(
  () => import('@ta/media.upload'),
  'MediaUploaderModalView',
  ({ mediaType }) => (
    <ModalView
      header={
        <TitleBar
          iconName={mediaType === 'photo' ? 'camera-fill' : 'video-fill'}
          displayType="LEFT_ALIGN_GRAY"
        >
          {mediaType === 'photo'
            ? localize('post_photos_form_header')
            : localize('post_a_video_modal_header')}
          ,
        </TitleBar>
      }
    >
      <div className={styles.wrapper}>
        <LoadingSpinner />
      </div>
    </ModalView>
  ),
);

const DeferredMediaUploaderModalView = ({
  onClose,
  closeGlobals,
  ...modalProps
}: DeferredMediaUploaderModalViewProps) => {
  // Hard to test
  /* istanbul ignore next */
  const passThroughOnClose = React.useCallback(() => {
    if (onClose) {
      onClose();
    }
    closeGlobals();
  }, [onClose, closeGlobals]);

  return <MediaUploaderModalView {...modalProps} onClose={passThroughOnClose} />;
};

const MediaUploaderModal = ({ modalName, ...modalViewProps }: Props) => (
  <Global name={modalName}>
    <Closer>
      {close => <DeferredMediaUploaderModalView {...modalViewProps} closeGlobals={close} />}
    </Closer>
  </Global>
);

export default MediaUploaderModal;
